import axios from "axios";

const USER_CODE_URL = process.env.REACT_APP_API_USER_CODE_URL;
const INNOVATION_CODE_URL = process.env.REACT_APP_API_INNOVATION_URL;

const getToken = (token) => ({Authorization: `Bearer ${token}`});

export const getAllCodeList = (token) => {
    return axios.get(`${USER_CODE_URL}`, {
        headers: getToken(token),
    });
};

export const getCodeHeadList = (token) => {
    return axios.get(`${USER_CODE_URL}/head`, {
        headers: getToken(token),
    });
}

export const getCodeList = (token, codes) => {
    return axios.get(`${USER_CODE_URL}/codes?codes=${codes.toString()}`, {
        headers: getToken(token),
    });
}

export const getInnovationCodeList = (token) => {
    return axios.get(`${INNOVATION_CODE_URL}/codes`, {
        headers: getToken(token),
    });
}